export const getSortedSceneSummeryData = (
  visitNoteData: any,
  visitData: any
) => {
  return {
    // done
    initialData: {
      incidentDate: visitData?.incidentDate || "-",
      incidentTime: visitData?.incidentTime || "-",
      unitDesignation: visitData?.unitDesignation || "-",
      unitType: visitData?.unitType || "-",
    },

    // in progress
    demographics: {
      // ---
      dob: visitData?.patient?.participant?.dateOfBirth || "-",
      age: `${visitData?.patient?.participant?.age}` || "-",
      gender: visitData?.patient?.participant?.gender || "-",
      registrationId: visitData?.patient?.participant?.registrationId || "-",
      // ---
      participantType: visitData?.patient?.participant?.participantType,
      unitNumber: visitData?.participant?.baseCamp?.unitNumber || "-",
      contactNumber: visitData?.patient?.participant?.contactNumber || "-",
    },

    // done
    incidentLocation: {
      incidentlocation: visitData?.incidentlocation || "-",
      chiefComplaints: visitData?.chiefComplaints || "-",
      witnessName: visitData?.witnessName || "-",
      witnessContact: visitData?.witnessContact || "-",
    },

    // done
    soapAndProc: {
      chiefComplaints: visitNoteData?.chiefComplaints || "-",
      subjectiveNote: visitNoteData?.subjectiveNote || "-",
      objectiveNote: visitNoteData?.objectiveNote || "-",
      assessment: visitNoteData?.assessmentDescription || "-",
      procedureDone: visitNoteData?.procedureDone || "-",
      vitals: visitData?.triage,
    },

    disposition: {
      // impressionDiagnosis is now stored as an array of codes; older records
      // may still be a plain string, so handle both.
      impressionDiagnosis: Array.isArray(
        visitNoteData?.disposition?.[0]?.impressionDiagnosis,
      )
        ? visitNoteData.disposition[0].impressionDiagnosis.join(", ") || "-"
        : visitNoteData?.disposition?.[0]?.impressionDiagnosis || "-",
      transferringUnit:
        visitNoteData?.disposition?.[0]?.transferringUnit || "-",
      dispositionData: visitNoteData?.disposition?.[0]?.dispositons,
      refusalOfMedicalAid: visitNoteData?.disposition?.[0]?.refusalOfMedicalAid,
      hospitalName: visitNoteData?.disposition?.[0]?.hospitalName || "-",
    },

    // done
    treatedAndRelease: {
      treatAndReleaseSelected:
        visitNoteData?.disposition?.[0]?.dispositons?.treatedAndReleased
          ?.radioButton || false,
      select:
        visitNoteData?.disposition?.[0]?.dispositons?.treatedAndReleased
          ?.select || false,
      signature:
        visitNoteData?.disposition?.[0]?.dispositons?.treatedAndReleased
          ?.signature,
    },
    iftSoapNote: visitNoteData?.iftSoapNote || "-",

    // done
    signature: {
      signature: visitNoteData?.disposition?.[0]?.signature?.signature,
      primaryClinic: visitNoteData?.disposition?.[0]?.signature?.primaryClinic,
      timeCallEnd: visitNoteData?.disposition?.[0]?.signature?.timeCallEnd,
    },
  };
};
